import { z } from "zod/v4";

export const SyncPricingFunctionResponseBodySchema = z.string();
export type SyncPricingFunctionResponseBodyType = z.infer<
  typeof SyncPricingFunctionResponseBodySchema
>;
